import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useSolicitudesMutations } from '../../hooks'
import { FooterPages } from '..';
import { getCentroCosto } from '../../services/CentroCostos';
import { getMaquinas } from '../../services/Maquinas';
import { crearMensaje, notificarUsuario } from '../../services/Util';
import { getCapacidadesTipo } from '../../services/Capacidades';
import { getMensajeRol } from '../../services/UsuarioSucursal';
import { crearLog } from '../../services/AuditoriaLogs';

import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { fetchUser } from '../../utils/fetchUser';
import DataTable from 'react-data-table-component';
import { Toaster,toast } from 'react-hot-toast';

import ButtonBar from '../ButtonBar';
import ButtonToolBar from '../ButtonToolBar';
import {formatDate} from '../../formatters/date';

const initialState = {
empresa:'',
numeroSolicitud: 0,
idCentro:'',
codigoCentro:'',
nombreProyecto:'',
ubicacion:'',
detalleEquipos: [],
observacionAd:'',
idMaquina:'',
capacidad:'',
idSolicitante: '',
idAprobador: '',
fechaAprobacion: '',
idJefeTecnico: '',
nombreJefeTecnico: '',
nombreSolicitante:'',
idAdministrador: '',
nombreAdministrador: '',
fechaCreacion: Date.now()
};

const NuevaSolicitud = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [centroData, setCentroData] = useState([]);
  const [equipoData, setEquipoData] = useState([]);
  const [capacidadData, setCapacidadData] = useState([]);
  const [archivosData, setArchivosData] = useState([]);
  const {addSolicitud, updateSolicitudC } = useSolicitudesMutations();
  const [selectedDateObra, setSelectedDateObra] = useState(getFirstDayOfMonth('Nada')); // Fecha inicial getFirstDayOfMonth('Fin')
  const [tipoSolicitud,setTipoSolicitud] = useState('Entrada');
  const [estado,setEstado] = useState('');
  const [permanencia,setPermanencia] = useState('1');
  const [esCritico,setEsCritico] = useState('NO');
  // const [personal,setPersonal] = useState('NO');
  // const [jornada,setJornada] = useState('');
  // const [turnos,setTurnos] = useState('');

  const [comentario,setComentario] = useState('');
  const [cantidad,setCantidad] = useState(1);
  const [cCosto,setCcosto] = useState('');
  const [esNuevo,setEsNuevo] = useState(true);
  const [idSolicitud,setIdSolicitud] = useState('');

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttons, setButtons] = useState([
    { name: 'add', label: 'Agregar', disabled: false },
  ]);
  const [buttonsTool, setButtonsTool] = useState([
    { name: 'cancel', label: 'Cancelar', disabled: false },
    { name: 'save', label: 'Guardar', disabled: false },
    { name: 'enviar', label: 'Enviar Aprobación', disabled: false },
  ]);
  const [buttonsToolAp, setButtonsToolAp] = useState([
    { name: 'rechazar', label: 'Rechazar', disabled: false },
    { name: 'aprobar', label: 'Aprobar', disabled: false },
  ]);

  const disableButton = (buttonName) => {
    setButtons((prevButtons) =>
      prevButtons.map((button) =>
        button.name === buttonName ? { ...button, disabled: true } : button
      )
    );
  };
  
  const disableButtonTool = (buttonName) => {
    setButtonsTool((prevButtons) =>
      prevButtons.map((button) =>
        button.name === buttonName ? { ...button, disabled: true } : button
      )
    );
  };

  const disableButtonToolAp = (buttonName) => {
    setButtonsToolAp((prevButtons) =>
      prevButtons.map((button) =>
        button.name === buttonName ? { ...button, disabled: true } : button
      )
    );
  };


  const userInfo = fetchUser();

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  useEffect(() => {
    // console.log(" estado" + estado);
    if(estado==='Aprobada' || estado==='Rechazada') {
      disableButton('add');
      disableButtonTool('save');
      disableButtonTool('enviar');
      disableButtonToolAp('rechazar');
      disableButtonToolAp('aprobar');
    } else if(estado==='En Proceso' && (userInfo.rol === 'Solicitante' || userInfo.rol === 'Administrador' || userInfo.rol === 'SuperUsuario')) {
      disableButton('add');
      disableButtonTool('save');
      disableButtonTool('enviar');
    } else if(estado ==='Pendiente') {
      disableButtonTool('cancel');
    }
  }, [estado]);

  useEffect(() => {
    if(vecinoData) {
      setTipoSolicitud(vecinoData.tipoSolicitud);
      setPermanencia('1');
      setComentario('');
      setEstado(vecinoData.estado);
      setCcosto(vecinoData.idCentro);
      setFormData(vecinoData);
      setArchivosData(vecinoData.detalleEquipos);
      setEsNuevo(false);
    } else {
      setEsNuevo(true);
    }
  }, [vecinoData]);


  useEffect(() => {

    if(vecinoData._id) 
      {
        setEsNuevo(false);
       // setSelectedDateObra(new Date(vecinoData.fechaEnObra));
      } else{
        setEsNuevo(true);
      //  setSelectedDateObra(getFirstDayOfMonth('Fin'));
        setFormData({...formData, idSolicitante: userInfo.usuario , nombreSolicitante: userInfo.nombre }); 
      }

    const fetchData = async () => {
      const misCentros = await getCentroCosto();
      setCentroData(misCentros);
      const misEquipos = await getMaquinas();
      setEquipoData(misEquipos);     
    };
    fetchData();
  },[]);

  useEffect(() => {
     //console.log(" centro costo" + cCosto );  
    if (cCosto !== "" && cCosto !== undefined){
      const cSel = centroData.find((item) => item._id === cCosto);
      if(cSel){
        //console.log(" centro costo" + JSON.stringify(cSel)); 
        setFormData({...formData, idCentro: cCosto ,nombreProyecto: cSel.nombreProyecto, ubicacion: cSel.ubicacion, nombreJefeTecnico: cSel.nombreAprobador  , nombreAdministrador: cSel.nombreAdministrador });
      }  
    } 
  }, [cCosto]);

  useEffect(() => {
    // console.log(" centro costo" + formData.idCentro);  
    if (formData.idMaquina !== ""){
      const fetchData = async () => {
          /// console.log(" MAQUINA " + formData.idMaquina );
          const cSelData = equipoData.find((item) => item._id === formData.idMaquina);
          if (cSelData){
            const cSel = await getCapacidadesTipo(cSelData.codigo);
            // console.log(" LOS DATOS DE CENTRO ENCONTRADO SON : " + cSel );
              if(cSel){
                setCapacidadData(cSel);
              }  
          }
      }
      fetchData();
    } 

  }, [formData.idMaquina]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  };

  const handleChangeTipoSolicitud = (e) =>{
    setTipoSolicitud( e.target.value );
  };

  const handleChangePermanencia = (e) =>{
    setPermanencia( e.target.value );
  };
 
  const handleChangeEsCritico = (e) =>{
    setEsCritico( e.target.value );
  };

  const handleChangeComentario = (e) =>{
    setComentario( e.target.value );
  };

  const handleChangeCantidad = (e) =>{
    setCantidad( e.target.value );
  };

  const handleChangeCentro = (e) =>{
    setCcosto( e.target.value );
  };
  
  const handleDateObraChange = (date) => {
    setSelectedDateObra(date);
  };

  const handleAgregaMaquina = async () =>{
    const newId = archivosData ? archivosData.length + 1 : 1 ;
    let miCapa = "";

    if (cantidad <= 0) {
      toast.error('La cantidad mínima es 1.');
      return;
    };

    if (formData.idMaquina === "") {
      toast.error('Debe seleccionar una Maquina.');
      return;
    };

    if (!selectedDateObra) {
      toast.error('Debe seleccionar una fecha en obra.');
      return;
    };

    // console.log(" MAQUINA " + formData.idMaquina );

      const cSelData = equipoData.find((item) => item._id === formData.idMaquina);
      
      if (cSelData && formData.capacidad !== "" ){
        const cSelDataCapa = capacidadData.find((item) => item._id === formData.capacidad);
        if (cSelDataCapa) {
          miCapa = cSelDataCapa.capacidad;
        }
        
      }
    
    const newData = {
      lin: newId,
      cantidad: cantidad,
      maquina: cSelData.codigo,
      capacidad:  miCapa,
      idMaquina: cSelData._id,
      permanencia: permanencia,
      comentario: comentario,
      selectedEquipo: 0,
      estadoEquipo: 'Pendiente',
      esCritico: esCritico,
      estadoImplementa:'Pendiente',
      fechaEnObra: selectedDateObra.toISOString()
    };

    setArchivosData((prevData) => [...prevData, newData]);

    setFormData({ idMaquina: "", capacidad: "" });
    setPermanencia('1');
    setEsCritico('NO');
    setComentario('');
    setCantidad(1);
  };

  const handleRechazar = async () =>{

    const today = new Date();

    if (estado !== 'En Proceso' ){
      toast.error('El estado de la solicitud no permite modificación.');
      return;
    }

    const updatosSolicitud = {
      _id: vecinoData._id,
      empresa: userInfo.empresa,
      tipoSolicitud: tipoSolicitud,
      idCentro:cCosto,
      observacionAd:formData.observacionAd,
      detalleEquipos: archivosData,
      idSolicitante: formData.idSolicitante,
      idAprobador: userInfo.usuario,
      fechaAprobacion: today.toISOString(),
      estado: 'Rechazada',
    };
    await updateSolicitudC.mutateAsync( updatosSolicitud );
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevasolicitud );

  };

  const handleAprobar = async () =>{
    const today = new Date();

    if (estado !== 'En Proceso' ){
      toast.error('El estado de la solicitud no permite modificación.');
      return;
    }

    const updatosSolicitud = {
      _id: vecinoData._id,
      empresa: userInfo.empresa,
      tipoSolicitud: tipoSolicitud,
      idCentro:cCosto,
      observacionAd:formData.observacionAd,
      detalleEquipos: archivosData,
      idSolicitante: formData.idSolicitante,
      idAprobador: userInfo.usuario,
      fechaAprobacion: today.toISOString(),
      estado: 'Aprobada',
    };

    const infoSol = await updateSolicitudC.mutateAsync( updatosSolicitud );

    const dataMensaje = {
    numeroSolicitud: infoSol.numeroSolicitud,
    codigoCentro: formData.codigoCentro,
    tipoSolicitud: infoSol.tipoSolicitud,
    observacionAd: infoSol.observacionAd };

    const mUser = await getMensajeRol('Logística');

    if (mUser){
      mUser.forEach(element => {     
        let mensaje = crearMensaje(element._id, 'solicitudAprobada', dataMensaje);
        notificarUsuario(JSON.stringify(mensaje));
      });
    }

    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevasolicitud );
  };

  const handleEnviarAprobacion = async () =>{
    if (!cCosto) {
      toast.error('Debe seleccionar un Centro de Costo.');
      return;
    }

    if (archivosData.length === 0){
      toast.error('Debe seleccionar a lo menos una Maquina.');
      return;
    }

    if (estado === 'Aprobada' || estado === 'Rechazada'){
      toast.error('El estado de la solicitud no permite modificación.');
      return;
    }
    
    if(esNuevo) 
    {
      const datosSolicitud = {
        empresa: userInfo.empresa,
        numeroSolicitud: 0,
        tipoSolicitud: tipoSolicitud,
        idCentro:cCosto,
        observacionAd: formData.observacionAd,
        detalleEquipos: archivosData,
        idSolicitante: userInfo.usuario,
        fechaCreacion: Date.now(),
        estado: 'En Proceso',
      };
      const infoSol =  await addSolicitud.mutateAsync( datosSolicitud );

      const desData = centroData.find((item) => item._id === cCosto);
      if (desData) {
        const dataMensaje = {
        numeroSolicitud: infoSol.numeroSolicitud,
        codigoCentro: desData.codigo,
        tipoSolicitud: infoSol.tipoSolicitud,
        observacionAd: infoSol.observacionAd };
        const mensaje = crearMensaje(desData.idAdministrador, 'aprobarSolicitud', dataMensaje);
        await notificarUsuario(JSON.stringify(mensaje));

        if (desData.idJefeTecnico !== ''){
          const mensajeTec = crearMensaje(desData.idJefeTecnico, 'aprobarSolicitud', dataMensaje);
          await notificarUsuario(JSON.stringify(mensajeTec));
        }

      }

    } else
    { 
      const updatosSolicitud = {
        _id: vecinoData._id,
        empresa: userInfo.empresa,
        tipoSolicitud: tipoSolicitud,
        idCentro:cCosto,
        observacionAd:formData.observacionAd,
        detalleEquipos: archivosData,
        idSolicitante: userInfo.usuario,
        estado: 'En Proceso',
      };
      const infoSol = await updateSolicitudC.mutateAsync( updatosSolicitud );

      const dataMensaje = {
      numeroSolicitud: infoSol.numeroSolicitud,
      codigoCentro: formData.codigoCentro,
      tipoSolicitud: infoSol.tipoSolicitud,
      observacionAd: infoSol.observacionAd };
      const mensaje = crearMensaje(formData.idAdministrador, 'aprobarSolicitud', dataMensaje);
      await notificarUsuario(JSON.stringify(mensaje));

      if (formData.idJefeTecnico !== ''){
        const mensajeTec = crearMensaje(formData.idJefeTecnico, 'aprobarSolicitud', dataMensaje);
        await notificarUsuario(JSON.stringify(mensajeTec));
      }

    }

    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevasolicitud );

  };

  const handleSubmit = async () =>{

    if (!cCosto) {
      toast.error('Debe seleccionar un Centro de Costo.');
      return;
    }

    if (archivosData.length === 0){
      toast.error('Debe seleccionar a lo menos una Maquina.');
      return;
    }

    if (estado === 'Aprobada' || estado === 'Rechazada'){
      toast.error('El estado de la solicitud no permite modificación.');
      return;
    }

    if(esNuevo) 
    {
      const datosSolicitud = {
        empresa: userInfo.empresa,
        numeroSolicitud: 0,
        tipoSolicitud: tipoSolicitud,
        idCentro:cCosto,
        observacionAd:formData.observacionAd,
        detalleEquipos: archivosData,
        idSolicitante: userInfo.usuario,
        fechaCreacion: Date.now(),
        estado: 'Pendiente',
      };
      //console.log(" datosSolicitud " + JSON.stringify(datosSolicitud));
      const miSol = await addSolicitud.mutateAsync( datosSolicitud );
      setIdSolicitud(miSol._id);
      setEsNuevo(false);
    } else
    { 
      const updatosSolicitud = {
        _id: vecinoData._id || idSolicitud,
        empresa: userInfo.empresa,
        tipoSolicitud: tipoSolicitud,
        idCentro:cCosto,
        observacionAd:formData.observacionAd,
        detalleEquipos: archivosData,
        idSolicitante: userInfo.usuario,
        estado: 'Pendiente',
      };
       await updateSolicitudC.mutateAsync( updatosSolicitud );
    };
    setFormData(initialState); 
 //   onChangeVecino('REFRESH');
 //   setIsClicked( !isClicked.nuevasolicitud );
  }
 
  const handleCancelar = async () =>{
    
    if (estado === 'Aprobada' || estado === 'Rechazada' || estado === 'Pendiente'){
      toast.error('El estado de la solicitud no permite modificación.');
      return;
    }

    if(vecinoData._id) 
    {
      const updatosSolicitud = {
        _id: vecinoData._id,
        empresa: userInfo.empresa,
        tipoSolicitud: tipoSolicitud,
        idCentro:cCosto,
        observacionAd:formData.observacionAd,
        detalleEquipos: archivosData,
        idSolicitante: userInfo.usuario,
        estado: 'Pendiente',
      };
       await updateSolicitudC.mutateAsync( updatosSolicitud );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevasolicitud );
  }

  const handleEliminar = async (row) => {
    if (estado === 'Aprobada' || estado === 'Rechazada'){
      toast.error('El estado de la solicitud no permite modificación.');
      return;
    } 

    if ((userInfo.rol !== 'SuperUsuario' || userInfo.rol !== 'Administrador' || userInfo.rol !== 'Logística' ) && estado === 'En Proceso'){
      toast.error('El Rol del usuario no permite modificación.');
      return;
    } 

    if ((userInfo.rol === 'SuperUsuario' || userInfo.rol !== 'Administrador' || userInfo.rol === 'Logística' ) && estado === 'En Proceso'){
      const dataLog = {
        empresa: userInfo.empresa,
        opcion: "Solicitudes",
        accion: "Eliminar",
        idUsuario: userInfo.usuario,
        numeroSolicitud: formData.numeroSolicitud,
        encabezado: " Proyecto " + formData.nombreProyecto + " N° Carpeta " + formData.numeroCarpeta ,
        detalle: "Usuario elimino Maquina " +  row.maquina
      };

      await crearLog(dataLog);
    } 
    setArchivosData((prevData) => prevData.filter((item) => item.lin !== row.lin));
    setArchivosData((prevData) =>(prevData));

  };

  const handleButtonClick = (buttonName) => {
   // console.log(`Button clicked: ${buttonName}`);
    // Realiza acciones basadas en el botón presionado
    if (buttonName === 'add') {
      handleAgregaMaquina();
    }
  };

  const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'save') {
      handleSubmit();
    } else if (buttonName === 'enviar') {
      handleEnviarAprobacion();
    } else if (buttonName === 'cancel') {
      handleCancelar();
    } else if (buttonName === 'aprobar') {
      handleAprobar();
    } else if (buttonName === 'rechazar') {
      handleRechazar();
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
      },
    },
    headRow: {
      style: {
        backgroundColor: 'white',
        fontSize: 12,
        borderRadius: 8,
        fontWeight: '400',
        color: '#AEB2D7',
        borderWidth: 0,
        textAlign: 'center',
        headerStyles:{
          backgroundColor: '#F2F5FE',
          fontWeight: 'bold',
          color: '#2F336A',
        },
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        margin: '4px 0px',
        backgroundColor: 'white',
        borderRadius: 8,
        fontSize: 10,
        rowStyles:{
          borderBottom: 1,
        }
      },
    },
  };

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'Lin',
      width: '40px',
      selector: row => row.lin,
      sortable: true
    },
    {
      name: 'Can.',
      width: '80px',
      selector: row => row.cantidad,
      sortable: true
    },
    {
      name: 'Maquina',
      width: '150px',
      selector: row => row.maquina,
      sortable: true
    },
    {
      name: 'Fecha en Obra',
      width: '150px',
      selector: row => row.fechaEnObra ? formatDate(row.fechaEnObra) : '',
      sortable: true
    },
    {
      name: 'Capacidad',
      width: '100px',
      selector: row => row.capacidad,
      sortable: true
    },
    {
      name: 'Permanencia',
      width: '100px',
      selector: row => row.permanencia,
      sortable: true
    },
    {
      name: 'Es Critico',
      width: '100px',
      selector: row => row.esCritico,
      sortable: true
    },
    {
      name: 'Comentario',
      width: '300px',
      selector: row => row.comentario,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <span>{row.comentario}</span>
      </div>
      )
    }
  ];

  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-full p-8">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nueva" : "Editar"} Solicitud
              </p>
            </div>

            <button
              type="button"
              onClick={() => { onChangeVecino('REFRESH'); setIsClicked(!isClicked.nuevasolicitud)}}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>

     <div className="bg-gray-200 p-6 rounded-lg shadow-lg">
        <div className="grid grid-cols-3 md:grid-cols-10 gap-4" >
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Tipo Solicitud*</label>
                <select className={inputClass} name="tipoSolicitud" 
                value= {tipoSolicitud} required 
                disabled= {!vecinoData._id ? false : true}
                onChange={handleChangeTipoSolicitud}>
                  <option value="Entrada">Entrada</option>
                  <option value="Salida">Salida</option>
                  <option value="Adicional">Adicional</option>
                  <option value="Reemplazo">Reemplazo</option>
                  <option value="Traspaso">Traspaso</option>
                </select>
            </div> 
            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Solicitud</label>            
                <input
                className={inputClass}
                type="text"
                placeholder=""
                name="numeroSolicitud"
                value= {vecinoData.numeroSolicitud}
                disabled
              />
            </div>

            <div className="flex flex-col items-start">      
              <label className="text-xs font-semibold mb-1">Fecha</label>            
              <input
                className={inputClass}
                type="text"
                placeholder=""
                name="fechaCreacion"
                value= {formatDate(vecinoData.fechaCreacion)}
                disabled
              />
            </div>
            <div className="col-span-2">
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Solicitante</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="nombreSolicitante"
                  value= {formData.nombreSolicitante}
                  disabled
                  onChange={handleChange}
                />
              </div>  
          </div> 

               <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Jefe Of. Técnica</label>
                    <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="nombreJefeTecnico"
                    value= {formData.nombreJefeTecnico}
                    disabled
                    onChange={handleChange}
                    />
                  </div> 
                </div>  
   
                  
                <div className="col-span-2">
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Administrador</label>
                      <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="nombreAdministrador"
                          value= {formData.nombreAdministrador}
                          disabled
                          onChange={handleChange}
                        />
                  </div> 
                </div> 

                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Estado</label>
                      <select className={inputClass} name="estado" value= {estado} disabled onChange={handleChangeEstado}>
                        <option value="Pendiente">Pendiente</option>
                        <option value="En Proceso">En Proceso</option>
                        <option value="Aprobada">Aprobada</option>
                        <option value="Rechazada">Rechazada</option>
                      </select>
                  </div>
            </div> 

          <div className="grid grid-cols-3 md:grid-cols-6 gap-4 mt-2" >
                <div className="col-span-2">
                 <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Centro Costo*</label>
                    <select className={inputClass} name="cCosto"  value={cCosto} onChange={handleChangeCentro}>
                    <option value=""></option>
                    {centroData?.map((item, index) => (
                      <option  key={item._id} value={item._id}>{item.codigo}</option>
                    ))}  
                    </select>
                  </div> 
                </div>
                <div className="col-span-2">
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Proyecto</label>
                        <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="nombreProyecto"
                          value= {formData.nombreProyecto}
                          disabled
                          onChange={handleChange}
                        />
                    </div>
                  </div>
                  <div className="col-span-2">
                        <div className="flex flex-col">
                            <label className="text-xs font-semibold mb-1">Ubicación</label>
                            <input
                                className={inputClass}
                                type="text"
                                placeholder=""
                                name="ubicacion"
                                value= {formData.ubicacion}
                                disabled
                                onChange={handleChange}
                              />
                          </div>
                    </div>
              </div>

            
               
        </div>   

          <div className="mt-5 space-y-4">
              <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-2 md:grid-cols-11 gap-4 gap-y-2">
                  <div className="flex flex-col col-span-1 md:col-span-1">
                    <label className="text-xs font-semibold mb-1">Cantidad*</label>
                    <input
                      className={inputClass}
                      type="number"
                      name="cantidad"
                      value={cantidad}
                      onChange={handleChangeCantidad}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 md:col-span-2">
                    <label className="text-xs font-semibold mb-1">Maquina*</label>
                    <select className={inputClass} name="idMaquina" value={formData.idMaquina} onChange={handleChange}>
                      <option value=""></option>
                      {equipoData?.map((item) => (
                        <option key={item._id} value={item._id}>{item.codigo}</option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col col-span-1 md:col-span-1">
                    <label className="text-xs font-semibold mb-1">Capacidad</label>
                    <select className={inputClass} name="capacidad" value={formData.capacidad} onChange={handleChange}>
                      <option value=""></option>
                      {capacidadData?.map((item) => (
                        <option key={item._id} value={item._id}>{item.capacidad}</option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col col-span-2 md:col-span-2">
                    <label className="text-xs font-semibold mb-1">Fecha en Obra*</label>
                    <div className="w-full">
                      <SeleccionaFecha
                        selectedDate={selectedDateObra}
                        handleDateChange={handleDateObraChange}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col col-span-1 md:col-span-1">
                    <label className="text-xs font-semibold mb-1">Permanencia(M)*</label>
                    <select className={inputClass} name="permanencia" value={permanencia} onChange={handleChangePermanencia}>
                      {[...Array(12).keys()].map(n => (
                        <option key={n + 1} value={n + 1}>{n + 1}</option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col col-span-1 md:col-span-1">
                    <label className="text-xs font-semibold mb-1">Es crítico</label>
                    <select className={inputClass} name="esCritico" value={esCritico} onChange={handleChangeEsCritico}>
                      <option value="SI">SI</option>
                      <option value="NO">NO</option>
                    </select>
                  </div>

                  <div className="flex flex-col col-span-2 md:col-span-2">
                    <label className="text-xs font-semibold mb-1">Comentario</label>
                    <input
                      className={inputClass}
                      type="text"
                      name="comentario"
                      value={comentario}
                      onChange={handleChangeComentario}
                    />
                  </div>

                  <div className="flex flex-col col-span-1 md:col-span-1 mt-5">
                    <ButtonBar buttons={buttons} onButtonClick={handleButtonClick} />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-4" >
                    <div className="flex flex-col">
                      <DataTable
                        columns={columns}
                        data={archivosData}
                        highlightOnHover
                        pagination={true}
                        striped
                        className="border border-gray-300 rounded-lg shadow-sm"
                        noHeader={true}
                        selectableRowsHighlight
                        customStyles={customStyles}
                        noDataComponent={'No hay Maquinas seleccionadas'}
                      />
                    </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                <div className="grid grid-cols-1 md:grid-cols-6 gap-4" >
                    <div className="col-span-4">
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Observación</label>
                          <input
                              className={inputClass}
                              type="text"
                              placeholder=""
                              name="observacionAd"
                              value= {formData.observacionAd}
                              onChange={handleChange}
                            />
                      </div>  
                    </div> 
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
              { (userInfo.rol === 'Solicitante' || userInfo.rol === 'Administrador'  || userInfo.rol === 'SuperUsuario') && 
                <div className="flex flex-col mt-4">
                  <ButtonToolBar buttons={buttonsTool} onButtonClick={handleButtonToolBarClick} />

                </div>
                }
                { userInfo.rol === 'Jefe de oficina técnica' &&
                <div className="flex flex-col mt-4">
                  <ButtonToolBar buttons={buttonsToolAp} onButtonClick={handleButtonToolBarClick} />
                </div>
                }


                </div>

              </div>   
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />         
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevaSolicitud;